import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants';

export const organizationService = {
    fetchBranding,
    updateBranding,
};

/** Public — no auth header (used on login pages). */
function fetchBranding() {
    return axiosInstance
        .get(api.organization.getBranding)
        .then(handleResponse)
        .then((data) => data)
        .catch((error) => handleError(error.response));
}

function updateBranding(brandingDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader(),
    };

    return axiosInstance
        .put(api.organization.updateBranding, brandingDetails, requestOptions)
        .then(handleResponse)
        .then((data) => data)
        .catch((error) => handleError(error.response));
}
